import classes from "./PinkBlock.module.scss";

const PinkBg = props => {
  return ( 
    <div className={classes.pinkBg + " " + (props.customClass ? props.customClass : "")}>
      <span className={classes.stepNum + " " + (props.CustomNumClass ? props.CustomNumClass : "")}>{props.number}</span>
  </div>
  )
}

export default PinkBg;